export default "__VITE_ASSET__CzEwgxI0__"